import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ListaCodigoTributacaoResponse } from '../../responses/servico/lista-codigo-tributacao.response';
import { CodigoTributacaoRequest } from '../../requests/servico/codigo-tributacao.request';

@Injectable({ providedIn: 'root' })
export class CodigoTributacaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiMotorFiscal + 'Lookup';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getLc116(request: CodigoTributacaoRequest): Observable<ListaCodigoTributacaoResponse> {
        let params = new HttpParams()
            .set('paginaAtual', request.paginaAtual.toString())
            .set('tamanhoPagina', request.tamanhoPagina.toString());

        if (request.pesquisa) {
            params = params.set('pesquisa', request.pesquisa);
        }

        return this.httpClient.get<ListaCodigoTributacaoResponse>(`${this.apiUrl}/lc116`, {
            params: params,
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public getTributacaoNacional(request: CodigoTributacaoRequest): Observable<ListaCodigoTributacaoResponse> {
        let params = new HttpParams()
            .set('paginaAtual', request.paginaAtual.toString())
            .set('tamanhoPagina', request.tamanhoPagina.toString());

        if (request.pesquisa) {
            params = params.set('pesquisa', request.pesquisa);
        }

        return this.httpClient.get<ListaCodigoTributacaoResponse>(`${this.apiUrl}/tributacao-nacional`, {
            params: params,
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }

    public getNbs(request: CodigoTributacaoRequest): Observable<ListaCodigoTributacaoResponse> {
        let params = new HttpParams()
            .set('paginaAtual', request.paginaAtual.toString())
            .set('tamanhoPagina', request.tamanhoPagina.toString());

        if (request.pesquisa) {
            params = params.set('pesquisa', request.pesquisa);
        }

        return this.httpClient.get<ListaCodigoTributacaoResponse>(`${this.apiUrl}/nbs`, {
            params: params,
            ...this.addHeaderToken()
        }).pipe(catchError(this.handleError));
    }
}
